import { useState } from 'react';
import Navbar from './components/Navbar';
import Ticker from './components/Ticker';
import Footer from './components/Footer';
import Home from './pages/Home';
import Nannies from './pages/Nannies';
import Vetting from './pages/Vetting';
import About from './pages/About';
import Pricing from './pages/Pricing';
import Consult from './pages/Consult';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Admin from './pages/Admin';

export default function App() {
  const [page, setPage] = useState(
    window.location.pathname === '/admin' ? 'admin' : 'home'
  );

  const go = (p) => { setPage(p); window.scrollTo(0, 0); };
  const handleBook = () => { setPage('consult'); window.scrollTo(0, 0); };

  if(page === 'admin') return <Admin go={go} />;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Ticker />
      <Navbar page={page} go={go} />
      <main style={{ flex: 1 }}>
        {page === 'home'    && <Home    go={go} onBook={handleBook} />}
        {page === 'nannies' && <Nannies go={go} onBook={handleBook} />}
        {page === 'vetting' && <Vetting go={go} />}
        {page === 'about'   && <About   go={go} />}
        {page === 'pricing' && <Pricing go={go} />}
        {page === 'consult' && <Consult go={go} />}
        {page === 'privacy' && <Privacy go={go} />}
        {page === 'terms'   && <Terms   go={go} />}
      </main>
      <Footer go={go} />
    </div>
  );
}